import { render, staticRenderFns } from "./LinksSection.vue?vue&type=template&id=2f87d1b2&scoped=true"
import script from "./LinksSection.vue?vue&type=script&lang=js"
export * from "./LinksSection.vue?vue&type=script&lang=js"
import style0 from "./LinksSection.vue?vue&type=style&index=0&id=2f87d1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87d1b2",
  null
  
)

export default component.exports